(function (scope) {
  'use strict';
  const unavailable = 'USD payments are currently unavailable. Please contact the store for assistance.';
  function parseAmount(raw) {
    const value = String(raw).trim();
    if (!/^\d+(?:\.\d{1,2})?$/.test(value)) throw new Error('Enter a positive amount with up to 2 decimal places.');
    const [whole, fraction = ''] = value.split('.');
    const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
    if (!Number.isSafeInteger(cents) || cents < 1 || Math.floor(cents / 100) > 2147483647) throw new Error('Enter a valid positive payment amount.');
    return cents;
  }
  const displayAmount = cents => `US$${(cents / 100).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}`;
  function configurationReady(config) {
    return config.enabled === true && config.currency === 'USD' && Number(config.dollarVariant?.price) === 100 && Number(config.centVariant?.price) === 1 && /^\d+$/.test(String(config.dollarVariant?.id)) && /^\d+$/.test(String(config.centVariant?.id));
  }
  function paymentLines(cents, config) {
    if (!configurationReady(config)) throw new Error(unavailable);
    const lines = [];
    for (const [quantity, unit] of [[Math.floor(cents / 100), config.dollarVariant], [cents % 100, config.centVariant]]) {
      if (!quantity) continue;
      if (unit.available !== true) throw new Error('This payment amount is currently unavailable. Please contact the store.');
      lines.push({id:String(unit.id), quantity});
    }
    return lines;
  }
  function checkoutUrl(cents, config, origin) {
    const lines = paymentLines(cents, config);
    const url = new URL(`${config.root || '/'}cart/${lines.map(line => `${line.id}:${line.quantity}`).join(',')}`, origin);
    if (url.origin !== new URL(origin).origin) throw new Error('The checkout address is unavailable.');
    url.searchParams.set('attributes[Payment amount]', displayAmount(cents));
    url.searchParams.set('locale', 'en');
    return url.href;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {parseAmount, displayAmount, configurationReady, paymentLines, checkoutUrl};
  if (!scope.document) return;
  const initialize = root => {
    root.querySelectorAll('[data-custom-payment]').forEach(section => {
      if (section.dataset.paymentInitialized) return;
      section.dataset.paymentInitialized = 'true';
      let config;
      try {config = JSON.parse(section.querySelector('[data-payment-config]').textContent);} catch {return;}
      const form = section.querySelector('[data-custom-payment-form]');
      const amount = section.querySelector('[data-payment-amount]');
      const total = section.querySelector('[data-payment-total]');
      const error = section.querySelector('[data-payment-error]');
      const status = section.querySelector('[data-payment-status]');
      const submit = section.querySelector('[data-payment-submit]');
      const ready = configurationReady(config);
      let busy = false;
      const report = message => {error.textContent = message || '';error.hidden = !message;amount.setAttribute('aria-invalid', message ? 'true' : 'false');};
      const update = showError => {
        let cents;
        try {
          cents = parseAmount(amount.value);
          total.textContent = displayAmount(cents);
          if (ready) paymentLines(cents, config);
          report('');
        } catch (e) {
          total.textContent = '—';
          if (showError) report(e.message);
          submit.disabled = true;
          return null;
        }
        submit.disabled = !ready || busy;
        return cents;
      };
      const preset = new URL(scope.location.href).searchParams.get('amount');
      if (preset !== null) {try {const cents = parseAmount(preset);amount.value = (cents / 100).toFixed(2);} catch {amount.value = '1.00';}}
      status.textContent = ready ? 'Continue to Shopify checkout to review your payment.' : unavailable;
      amount.addEventListener('input', () => update(true));
      amount.addEventListener('blur', () => {const cents = update(true);if (cents !== null) amount.value = (cents / 100).toFixed(2);});
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const cents = update(true);
        if (cents === null || !ready || busy) return;
        busy = true;submit.disabled = true;section.querySelector('.payment-card').setAttribute('aria-busy','true');
        try {
          // Confirm native current-market prices again before entering a payment checkout.
          const [cartResponse, productResponse] = await Promise.all([
            fetch(`${config.cartUrl || '/cart'}.js`, {credentials:'same-origin',headers:{Accept:'application/json'}}),
            fetch(`${config.productUrl}.js`, {credentials:'same-origin',headers:{Accept:'application/json'}})
          ]);
          if (!cartResponse.ok || !productResponse.ok) throw new Error('Payment could not be verified. Please try again.');
          const [cart, product] = await Promise.all([cartResponse.json(), productResponse.json()]);
          const nativeVariant = id => product.variants.find(variant => String(variant.id) === String(id));
          const verified = {...config, currency:cart.currency,dollarVariant:nativeVariant(config.dollarVariant.id),centVariant:nativeVariant(config.centVariant.id)};
          const url = checkoutUrl(cents, verified, scope.location.origin);
          scope.location.assign(url);
        } catch (e) {
          busy = false;section.querySelector('.payment-card').removeAttribute('aria-busy');update(false);
          report(e.message || 'Payment could not be verified. Please try again.');
        }
      });
      update(false);
    });
  };
  if (scope.document.readyState === 'loading') scope.document.addEventListener('DOMContentLoaded', () => initialize(scope.document));
  else initialize(scope.document);
  scope.document.addEventListener('shopify:section:load', event => initialize(event.target));
})(typeof window !== 'undefined' ? window : globalThis);
